import { useNavigate } from '@tanstack/react-router';
import { useCallback, useEffect } from 'react';
import { ChatView } from '../../components/chat/ChatView';

/** `/app` opens Home; existing conversations remain in Recent chats. */
export function NewChatPage() {
  const navigate = useNavigate();
  useEffect(() => {
    void navigate({ to: '/app/brief', replace: true });
  }, [navigate]);
  return null;
}

/**
 * `/app/new` is a local draft. Creating the server conversation is part of
 * the first send, so merely visiting this route never adds a recent chat.
 */
export function NewConversationPage() {
  const navigate = useNavigate();
  const openPersistedConversation = useCallback((conversationId: string) => {
    void navigate({
      to: '/app/c/$conversationId',
      params: { conversationId },
      replace: true,
    });
  }, [navigate]);

  return <ChatView conversationId={null} onConversationSettled={openPersistedConversation} />;
}
